import { Provider } from '@angular/core';

import { AccessService } from '@core-interactions/services/access.service';
import { ACCESS_STORE } from '@core-interactions/stores/access.store';

export const CORE_INTERACTIONS_PROVIDERS: Provider[] = [
  AccessService,
  ACCESS_STORE
];
